export const UserTypes = {
    IAuthService: Symbol("IAuthService"),
    IIdpAuthService: Symbol("IIdpAuthService"),
};
